<template>
  <v-app>
    <NavBar v-show="$route.name!=='home'" />
    <v-content>
      <v-container>
        <Logo v-show="$route.name==='home'"/>
        <router-view/>
        <CookiePrompt v-if="showCookiePrompt != 'false'"/>
        <!-- <v-row justify=space-around align-content="center">
          <v-col>
            <Adsense
              data-ad-client="ca-pub-0588060391204034"
              data-ad-slot="2586789521"
              :data-full-width-responsive=true
              :data-ad-format="autorelaxed"
            >
            </Adsense>
          </v-col>
        </v-row> -->
      </v-container>
    </v-content>
    <Footer/>
  </v-app>
</template>

<script>

import NavBar from './components/NavBar.vue';
import Logo from './components/Logo.vue';
import CookiePrompt from './components/CookiePrompt.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: { 
    Logo,
    CookiePrompt,
    Footer,
    NavBar,
  },
  data: () => ({
    showCookiePrompt: localStorage.showCookiePrompt
  }),
};
</script>

<style>
ins {
    display: block;
}
</style>